// src/components/Dashboard/PlayerDashboard/PendingActionsWidget.jsx
// Action queue showing pending items that need player attention

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FaBell, FaQuestionCircle, FaTasks, FaPaperPlane, 
  FaCreditCard, FaArrowRight 
} from 'react-icons/fa';
import styles from './PendingActionsWidget.module.css';

const PendingActionsWidget = ({ 
  pendingRsvps = 0, 
  pendingAssignments = 0, 
  pendingApps = 0,
  refreshTrigger 
}) => {
  const navigate = useNavigate();

  const totalActions = pendingRsvps + pendingAssignments + pendingApps;

  const actionItems = [
    {
      id: 'rsvp',
      icon: FaQuestionCircle,
      label: 'RSVPs',
      count: pendingRsvps,
      description: 'Events awaiting your response',
      color: '#F59E0B',
      onClick: () => navigate('/events')
    },
    {
      id: 'tasks',
      icon: FaTasks,
      label: 'Tasks',
      count: pendingAssignments,
      description: 'Assignments to complete',
      color: '#3b82f6',
      onClick: () => navigate('/assignments')
    },
    {
      id: 'apps',
      icon: FaPaperPlane,
      label: 'Applications',
      count: pendingApps,
      description: 'Pending applications',
      color: '#8b5cf6',
      onClick: () => {} // No specific page
    },
    {
      id: 'fees',
      icon: FaCreditCard,
      label: 'Fees',
      count: 0, // TODO: Implement fees tracking
      description: 'Outstanding payments',
      color: '#ef4444',
      onClick: () => {}
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <FaBell className={styles.headerIcon} />
          <h3 className={styles.headerTitle}>Needs Your Attention</h3>
        </div>
        {totalActions > 0 && (
          <span className={styles.totalBadge}>{totalActions} total</span>
        )}
      </div>

      <div className={styles.content}>
        <div className={styles.actionsGrid}>
          {actionItems.map((item) => {
            const hasItems = item.count > 0;
            return (
              <button
                key={item.id}
                className={`${styles.actionCard} ${hasItems ? styles.hasItems : styles.noItems}`}
                onClick={item.onClick}
                style={{ '--action-color': item.color }}
              >
                <div className={styles.cardIcon}>
                  <item.icon />
                </div>
                <div className={styles.cardContent}>
                  <span className={styles.cardCount}>{item.count}</span>
                  <span className={styles.cardLabel}>{item.label}</span>
                </div>
                {hasItems && (
                  <div className={styles.cardAction}>
                    <FaArrowRight />
                  </div>
                )}
              </button>
            );
          })}
        </div>

        {totalActions === 0 && (
          <div className={styles.allCaughtUp}>
            <span className={styles.successIcon}>✅</span>
            <span>You're all caught up!</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingActionsWidget;

